export default {
    setSidebarCollapsed(state, collapsed) {
        state.isSidebarCollapsed = !!collapsed
        try {
            localStorage.setItem('ui.sidebarCollapsed', collapsed ? '1' : '0')
        } catch (e) {
            /* ignore */
        }
    },
    setMobileMenuOpen(state, open) {
        state.isMobileMenuOpen = !!open
    }
}
